import clsx from 'clsx'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { getRegionUrl } from '@/helpers/getCountryCode'

interface HeaderProps {
  hideBurger?: boolean
  desktop?: boolean
  version?: boolean
}

const Header = (props: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const region = localStorage.getItem('region') || 'US'
  const privacyPolicyRoute = getRegionUrl(region, 'privacy-policy')
  const termsRoute = getRegionUrl(region, 'terms-of-use')

  return (
    <>
      <header
        className={clsx('flex z-20 justify-center items-center relative border-b border-white20', {
          'desk:justify-start desk:': props.desktop,
        })}
      >
        <div
          className={clsx({
            'max-w-[980px] desk:py-[25px] desk:px-2.5 desk:mx-auto desk:w-full': props.desktop,
          })}
        >
          <figure
            className={clsx('flex flex-row items-center gap-3 py-2', {
              'desk:gap-5': props.desktop,
            })}
          >
            <img
              src="/quiz/icons/logo.png"
              alt="Clean Master"
              className={clsx('w-9 h-9', {
                'desk:w-16 desk:h-16': props.desktop,
              })}
            />

            <h1
              className={clsx('text-logo font-bold', {
                'desk:text-[22px]': props.desktop,
              })}
            >
              Clean Master
            </h1>
          </figure>
          <button
            className={clsx(
              'absolute w-6 h-6 bg-burgerLight dark:bg-burger bg-no-repeat bg-[center_center] top-1/2 right-2 -translate-y-1/2',
              {
                hidden: props.hideBurger,
              },
            )}
            style={{ backgroundSize: '16px' }}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          ></button>
        </div>
      </header>
      <div
        className={clsx('fixed w-full h-full bg-black/50 z-[2] inset-0', {
          'visible opacity-100 transition-opacity duration-300': isMenuOpen,
          'opacity-0 pointer-events-none transition-opacity duration-300': !isMenuOpen,
        })}
        onClick={() => setIsMenuOpen(false)}
      ></div>
      <nav
        className={clsx(
          'h-[100dvh] fixed z-[30] right-0 top-0 py-[88px] px-6 border-l dark:border-l-0 transition-transform duration-300 w-[300px] box-border bg-black  dark:bg-navBg',
          {
            'translate-x-full transition-transform duration-300': !isMenuOpen,
            'translate-x-0': isMenuOpen,
          },
        )}
      >
        <button
          className="absolute  bg-closeButtonCross bg-no-repeat outline-none bg-[center_center] w-10 h-10 top-4 left-6 rounded-2.5xl bg-white15"
          onClick={() => setIsMenuOpen(false)}
        ></button>
        <div
          className={clsx(
            'flex flex-col gap-6 [&>a]:inline-block [&>a]:text-LXL2  [&>a]:text-white',
            {
              '[&>a]:font-semibold': !props.version,
              '[&>a]:font-medium': props.version,
            },
          )}
        >
          <Link to={{ pathname: termsRoute }}>Terms of Use</Link>
          <Link to={{ pathname: privacyPolicyRoute }}>Privacy Policy</Link>
        </div>
      </nav>
    </>
  )
}

export default Header
